<div class="sh-fixed-header-panel">
  <div class="sh-fixed-header-panel__head">
    <div class="sh-fixed-header-panel__head__title">{{ "facets.title" | translate }}</div>
    @if ((selectedFacets$ | async)?.length) {
      <sh-facet-summary
        [selectedFacets]="selectedFacets$ | async"
        [chosenFiltersMsg]="'facets.summary.chosen' | translate"
        [clearMsg]="'facets.summary.clear' | translate"
        (clear)="onClear()"
        (removeFacetValue)="onRemoveFacet($event)"
      ></sh-facet-summary>
    }
  </div>
  <div class="sh-fixed-header-panel__content">
    @if (facetsLoading$ | async) {
      <div class="sh-facet-list" [@fadeOut]>
        @for (_ of [].constructor(4); track _) {
          <sh-facet-placeholder></sh-facet-placeholder>
        }
      </div>
    }

    @if (error$ | async) {
      <p>{{ "ui.loading-failed" | translate }}</p>
    } @else {
      @if (selectableFacets$ | async; as facets) {
        @if (facetProfile$ | async; as facetProfile) {
          @if (!(facetsLoading$ | async)) {
            @if (facets.length > 0) {
              <sh-facet-list
                [ngStyle]="{ display: (facetsLoading$ | async) ? 'none' : 'inherit' }"
                [facets]="facets"
                [showMoreMsg]="'facets.search-more' | translate"
                (facetSelected)="onFacetSelected($event)"
                (loadMore)="onLoadMore($event, facetProfile)"
                [@fadeIn]
              ></sh-facet-list>
            } @else {
              {{ "facets.no-results" | translate }}
            }
          }
        }
      }
    }
  </div>
</div>

